'use client';

import { produce } from 'immer';
import { FC, ReactNode } from 'react';

import { storeFactory } from './storeFactory';

export type DisplayMode = 'popular' | 'all';

interface FilterSidebarStoreStateData {
  initialOpenIndexes: number[];
  displayMode: DisplayMode;
  scrollPosition: number;
}

interface FilterSidebarStoreStateFunctions {
  setInitialOpenIndexes: (initialOpenIndexes: number[]) => void;
  setDisplayMode: (displayMode: 'popular' | 'all') => void;
  setScrollPosition: (scrollPosition: number) => void;
}

const {
  store: filterSidebarStore,
  StoreProvider: FilterSidebarStoreProvider,
  useCreateStore: useCreateFilterSidebarStore,
} = storeFactory<FilterSidebarStoreStateData, FilterSidebarStoreStateFunctions>(
  () => ({
    initialOpenIndexes: [0],
    displayMode: 'popular',
    scrollPosition: 0,
  }),
  (set) => ({
    setInitialOpenIndexes: (initialOpenIndex: number[]) => {
      set((state) =>
        produce(state, (draft) => {
          draft.initialOpenIndexes = initialOpenIndex;
        }),
      );
    },
    setDisplayMode: (displayMode: 'popular' | 'all') => {
      set((state) =>
        produce(state, (draft) => {
          draft.displayMode = displayMode;
        }),
      );
    },
    setScrollPosition: (scrollPosition: number) => {
      set((state) =>
        produce(state, (draft) => {
          draft.scrollPosition = scrollPosition;
        }),
      );
    },
  }),
);

export { filterSidebarStore };

export const FilterSidebarStore: FC<{ children: ReactNode }> = ({ children }) => {
  const createFilterSidebarStore = useCreateFilterSidebarStore({});

  return <FilterSidebarStoreProvider createStore={createFilterSidebarStore}>{children}</FilterSidebarStoreProvider>;
};
